import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

type DeleteFlipConfirmationDialogProps = {
  orderNumber: string | null;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
};

const DeleteFlipConfirmationDialog = ({
  orderNumber,
  isDeleting,
  onClose,
  onConfirm
}: DeleteFlipConfirmationDialogProps) => (
  <Dialog open={Boolean(orderNumber)} onClose={isDeleting ? undefined : onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Delete Flip</DialogTitle>
    <DialogContent>
      <Typography>
        Are you sure you want to remove the flip for order {orderNumber}?
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={isDeleting}>
        Cancel
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained" disabled={isDeleting}>
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteFlipConfirmationDialog;
